import { updateActionState } from '../../../../../store/appStateSlice';

export default function confirm() {
  updateActionState('btnConfirm');
}
